import {Component, OnInit} from '@angular/core';
import {AbstractGamePlayComponent} from "../abstract-game-play.component";
import {GamePlay} from "../../model/game-play";
import {DEFAULT_FIRST_DOWN_DISTANCE} from "../../helpers/distance";
import {Down} from "../../model/down";
import {ODK} from "../../model/odk";
import { TopSectionComponent } from '../../components/top-section/top-section.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-select-play-option-overtime',
    templateUrl: './select-play-option-overtime.component.html',
    styleUrls: ['./select-play-option-overtime.component.scss'],
    imports: [TopSectionComponent, TranslocoModule]
})
export class SelectPlayOptionOvertimeComponent extends AbstractGamePlayComponent implements OnInit {
  gamePlay!: GamePlay


  ngOnInit(): void {
    this.gamePlay = this.game.getFirstPendingGamePlay();
    if (this.gamePlay.gamePlayNumber === 1) {
      //il a eu refresh et on s'assure de reload la game
      this.router.navigate(['game-play'])
    }
    this.gamePlay.yardLine = '35'
    this.gamePlay.distance = DEFAULT_FIRST_DOWN_DISTANCE
    this.gamePlay.down = Down.D1
    this.gamePlay.qtr = 5
  }

  homePossession() {
    this.gamePlay.odk = ODK.Offensive
    this.router.navigate(['game-play'])
  }

  awayPossession() {
    this.gamePlay.odk = ODK.Defensive
    this.router.navigate(['game-play'])
  }
}
